import { render, staticRenderFns } from "./ProgramsPage.vue?vue&type=template&id=045ac4e6&scoped=true"
import script from "./ProgramsPage.vue?vue&type=script&lang=js"
export * from "./ProgramsPage.vue?vue&type=script&lang=js"
import style0 from "./ProgramsPage.vue?vue&type=style&index=0&id=045ac4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ac4e6",
  null
  
)

export default component.exports